module.exports = __webpack_public_path__ + "img/PowerUsageModule.7600b981.gif";